import React from 'react'
import {
  faStethoscope,
  faHospital,
  faBriefcase,
  faUser,
  faShoppingBag,
  faFileArrowDown
} from '@fortawesome/free-solid-svg-icons'
import { Switch, Route, RouteComponentProps, Redirect } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Nav, AdminLogo } from '@doseme/cohesive-ui'

import {
  HOSPITALS_URL,
  ROOT_URL,
  USERS_URL,
  PLANS_URL,
  SSO_REALMS_URL,
  INSTALLATIONS_URL,
  REPORTS_URL
} from '../../constants/urls/frontend'
import { NavMenu } from '../../components/NavMenu'
import { HospitalsPage } from './HospitalsPage'
import { InstallationsPage } from './InstallationsPage'
import { Footer } from '../../components/Footer'
import { UsersPage } from './UsersPage'
import { SSORealmsPage } from './SSORealmsPage'
import { PlansPage } from './PlansPage/PlansPage'
import { ReportsPage } from './ReportsPage'

import './index.scss'

const Dashboard: React.FC<RouteComponentProps> = ({ history }) => {
  const sideNavLinks: Nav.INavLink[] = [
    {
      icon: <FontAwesomeIcon className='m-2' icon={faHospital} />,
      label: 'Hospitals',
      route: HOSPITALS_URL
    },
    {
      icon: <FontAwesomeIcon className='m-2' icon={faBriefcase} />,
      label: 'Plans',
      route: PLANS_URL
    },
    {
      icon: <FontAwesomeIcon className='m-2' icon={faUser} />,
      label: 'Users',
      route: USERS_URL
    },
    {
      icon: <FontAwesomeIcon className='m-2' icon={faStethoscope} />,
      label: 'Installations',
      route: INSTALLATIONS_URL
    },
    {
      icon: <FontAwesomeIcon className='m-2' icon={faShoppingBag} />,
      label: 'SSO Realms',
      route: SSO_REALMS_URL
    },
    {
      icon: <FontAwesomeIcon className='m-2' icon={faFileArrowDown} />,
      label: 'Reports',
      route: REPORTS_URL
    }
  ]

  const topNav = <Nav.TopNav logo={<AdminLogo />} menu={<NavMenu />} />

  const sideNav = <Nav.SideNav navLinks={sideNavLinks} handleNavTo={(route) => history.push(route)} />

  return (
    <Nav.NavLayout topNav={topNav} sideNav={sideNav} footer={<Footer />}>
      <Switch>
        <Route path={HOSPITALS_URL} component={HospitalsPage} />
        <Route path={PLANS_URL} component={PlansPage} />
        <Route path={USERS_URL} component={UsersPage} />
        <Route path={INSTALLATIONS_URL} component={InstallationsPage} />
        <Route path={SSO_REALMS_URL} component={SSORealmsPage} />
        <Route path={REPORTS_URL} component={ReportsPage} />
        <Redirect from={ROOT_URL} to='/hospitals' exact />
      </Switch>
    </Nav.NavLayout>
  )
}

export { Dashboard }
